import Navbar from "./header/navbar";
import Menu from "./header/menu";
import MobileNavbar from "./header/mobile-navbar";
import DashboardNavbar from "./header/dashboard-navbar";

import { Button } from "./ui/button";
import Icons from "./ui/icons";
import { Badge } from "./ui/badge";

import SidebarWrapper from "./wrappers/SidebarWrapper";

import EditProductSection from "./sections/product-manage/EditProductSection";
import ProductManageSection from "./sections/product-manage/ProductManageSection";
import DashboardSection from "./sections/dashboard-section";
import HomeSection from "./sections/home-section";
import LoginSection from "./sections/login-section";
import RegisterSection from "./sections/register-section";
import ForgetPasswordSection from "./sections/forgot-password-section";
import VerifyPhoneSection from "./sections/verify-phone-section";

import AuthProvider from "./providers/SessionProvider";

import DynamicSelect from "./utils/DynamicSelect";
import TagInputs from "./utils/TagInputs";
import Notification from "./utils/Notification";
import AnimationContainer from "./utils/animation-container";
import AnimatedSwitch from "./utils/animation-switch";
import Background from "./utils/background";
import SectionContainer from "./utils/section-container";
import OtpInput from "./utils/otp-input";
import { AnimatedCircularProgress } from "./utils/animated-circular-progress-bar";

import HeroImage from "./contents/hero-image";
import Hero from "./contents/hero";
import Games from "./contents/games";
import Platforms from "./contents/platforms";
import Thumbnail from "./contents/thumbnail";
import BlurBox from "./contents/blurbox";
import Shoppingcard from "./contents/shoppingcard";
import Bimageslider from "./contents/bimageslider";
import Blogposts from "./contents/blogposts";

import Companies from "./contents/companies";
import Services from "./contents/services";
import Features from "./contents/features";
import Offerings from "./contents/offerings";
import Pricing from "./contents/pricing";
import Banner from "./contents/banner";
import Testimonial from "./contents/testimonial";
import Tools from "./contents/tools";
import Newsletter from "./contents/newsletter";
import Footer from "./contents/footer";
import DashboardCards from "./contents/DashboardCards";
import FeatureSection from "./contents/FeatureSection";
import { FeaturesGridSection } from "./contents/FeatureGridSection";
export {
   SidebarWrapper,
   DashboardNavbar,
   Navbar,
   Menu,
   MobileNavbar,
   Button,
   Icons,
   Badge,
   EditProductSection,
   ProductManageSection,
   DashboardSection,
   HomeSection,
   LoginSection,
   RegisterSection,
   ForgetPasswordSection,
   VerifyPhoneSection,
   AuthProvider,
   DynamicSelect,
   TagInputs,
   Notification,
   AnimationContainer,
   AnimatedSwitch,
   Background,
   SectionContainer,
   OtpInput,
   AnimatedCircularProgress,
   HeroImage,
   Hero,
   Games,
   Platforms,
   Thumbnail,
   BlurBox,
   Shoppingcard,
   Bimageslider,
   Blogposts,
   Companies,
   Services,
   Features,
   Offerings,
   Pricing,
   Banner,
   Testimonial,
   Tools,
   Newsletter,
   Footer,
   DashboardCards,
   FeatureSection,
   FeaturesGridSection,
};
